import { useApiClient } from '../client'

export const STRIPE_CONNECTION_TOKEN = '/core/v2/business_api/me/businesses/{businessId}/stripe/connection_token'

import type { StripeConnectionTokenResponse } from '@/api/types/stripe'

export function getStripeConnectionToken (businessId) {
  const apiClient = useApiClient()

  return apiClient.get<StripeConnectionTokenResponse>({
    url: STRIPE_CONNECTION_TOKEN,
    urlParams: {
      businessId,
    },
  })
}
